import { useState } from 'react';

import { today } from '../../dates';
import { useDashboard } from '../../hooks/dashboard';

import { Greeting } from '../greeting';
import { InvitationsWaiting } from '../invitations-waiting';
import { LoadFailed } from '../load-failed';
import { QuestionnairesToReview } from '../questionnaires-to-review';

import styles from './style.module.css';

// The clinician's home page (C33), reached through the psy brand: the
// greeting with the date, then what waits for them: the submitted tests they
// have not reviewed and the invitations not yet answered. Today's sessions
// and notes to finish join with the features that produce them.
export function Dashboard() {
  const [ day ] = useState(today);
  const { data, error, retry } = useDashboard();

  if (error != null) {
    return <LoadFailed onRetry={ retry }/>;
  }

  if (data === undefined) {
    return null;
  }

  return (
    <section className={ styles.dashboard }>
      <Greeting day={ day }/>

      <div className={ styles.columns }>
        <QuestionnairesToReview tests={ data.toReview }/>

        <InvitationsWaiting invitations={ data.sentInvitations }/>
      </div>
    </section>
  );
}
